module.exports = __webpack_public_path__ + "img/brand-maddox-country.20fb097b.png";